var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMoney(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1662542503297,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 54532,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 200,
    height: 200,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M364.2 288.3l315.3-0.9c14.6-1.7 68.2-63.5 80.6-128.7C772 97 736.2 77.4 646.6 77.4c-89.9 0-71.3 86.6-89.4 86.6-10.5 0-20-66.5-61-94.7-29.2-20.1-69.7 31.7-108.5 32.1-45.2 0.4-104.2-5.3-104.2 60.8 0 54.6 65.2 126.1 80.7 126.1z m-15.9 0c-11.7 0-21.3 5.1-21.3 11.2 0 6.2 9.5 11.2 21.3 11.2h327.4c11.8 0 21.3-5 21.3-11.2 0-6.1-9.5-11.2-21.3-11.2H348.3z m352 44.7H331c-119.8 69.7-221.6 205.6-221.6 384.3 0 197 190.2 242 407.3 242 217 0 397.9-47.2 397.9-244.3-0.1-165.5-87.9-308.7-214.3-382zM577 564.6c14.4 0 26 10.7 26 23.9s-11.6 23.9-26 23.9h-52v23.9h52c14.4 0 26 10.7 26 23.9s-11.6 23.9-26 23.9h-52v50.2c0 13.2-11.6 23.9-26 23.9-14.3 0-26-10.7-26-23.9V684h-52c-14.4 0-26-10.7-26-23.9s11.6-23.9 26-23.9h52v-23.9h-52c-14.4 0-26-10.7-26-23.9s11.6-23.9 26-23.9h52v-13.9l-72.9-64.8c-9.5-8.1-10.6-22.3-2.5-31.8 0.6-0.7 1.2-1.4 1.9-2 10.3-9.5 26.1-9.7 36.8-0.6l64.8 57.6 64.8-57.6c10.6-9.1 26.4-8.9 36.8 0.6 10 9.5 9.7 24.6-0.6 33.8l-76.9 68.3v10.4l51.8 0.1z",
    fill: "#ffffff",
    "p-id": 54533
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMoney);
export default __webpack_public_path__ + "static/media/money.34328dae.svg";
export { ForwardRef as ReactComponent };